import { camelCase, capitalize, kebabCase, trim } from 'lodash-es';

/**
 * Convert snake_case table name to PascalCase query name
 * Example: SERVICE_PARAM -> ServiceParam
 * Uses lodash-es for consistent string transformations
 */
export const toPascalCase = (str: string): string => {
  return str
    .split('_')
    .map(word => capitalize(word.toLowerCase()))
    .join('');
};

/**
 * Convert snake_case to camelCase
 * Uses lodash-es camelCase for consistent transformations
 */
export const toCamelCase = (str: string): string => {
  return camelCase(str);
};

/**
 * Convert string to kebab-case
 * Uses lodash-es kebabCase for consistent transformations
 */
export const toKebabCase = (str: string): string => {
  return kebabCase(str);
};

/**
 * Trim whitespace from string
 * Uses lodash-es trim for consistent behavior
 */
export const trimString = (str: string): string => {
  return trim(str);
};

/**
 * Capitalize first letter of string
 * Uses lodash-es capitalize for consistent behavior
 */
export const capitalizeString = (str: string): string => {
  return capitalize(str);
};
